import React from 'react';

import cn from 'classnames';
import { Icon } from '@picsio/ui';
import { Info } from '@picsio/icons';

import Tooltip from '../../Tooltip/Tooltip';
import s from '../styles.module.scss';

export default function buildComplianceFieldLabel({
  label,
  diff,
  infoTooltip,
  dimLabel,
}) {
  return (
    <span className={s.complianceFieldLabel}>
      <Tooltip content={diff ? 'Unpublished changes' : null} placement="top">
        <span className={cn(diff && s.diffDot, dimLabel && s.dimmedFieldLabel)}>{label}</span>
      </Tooltip>
      <If condition={infoTooltip}>
        <Tooltip content={infoTooltip} placement="top">
          <span className={s.complianceFieldInfo}>
            <Icon size="sm">
              <Info />
            </Icon>
          </span>
        </Tooltip>
      </If>
    </span>
  );
}
